import colors from '@/theme/colors';
import { TCreatorApplicantType, TCreatorApplicationStatus } from '@/types/CreatorApplication.types';
import { Text } from '@chakra-ui/react';
import { format } from 'date-fns';
import React from 'react';

const STATUS_COLOR: Record<TCreatorApplicationStatus, string> = {
  pending: colors.extra.orange,
  approved: colors.extra.teal,
  rejected: colors.extra.red,
};

const STATUS_LABEL: Record<TCreatorApplicationStatus, string> = {
  pending: 'Pending',
  approved: 'Approved',
  rejected: 'Rejected',
};

const APPLICANT_TYPE_LABEL: Record<TCreatorApplicantType, string> = {
  existing_user: 'Existing user',
  external_email: 'External email',
};

export const getCreatorApplicationStatusLabel = (
  status?: TCreatorApplicationStatus | null,
): string => (status ? STATUS_LABEL[status] : 'Draft');

export const getCreatorApplicantTypeLabel = (type: TCreatorApplicantType): string =>
  APPLICANT_TYPE_LABEL[type];

export const formatCreatorApplicationDate = (value?: string | null): string =>
  value ? format(new Date(value), 'MMM d, yyyy') : '/';

interface StatusBadgeProps {
  status?: TCreatorApplicationStatus | null;
}

export const CreatorApplicationStatusBadge = ({ status }: StatusBadgeProps) => {
  const color = status ? STATUS_COLOR[status] : colors.text.mediumGray;

  return (
    <Text
      as="span"
      color={color}
      fontWeight={700}
      fontSize="13px"
      textTransform="uppercase"
      letterSpacing="0.5px"
    >
      {getCreatorApplicationStatusLabel(status)}
    </Text>
  );
};
